import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbsDown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M13.7778 2.9375H5.10026C4.28276 2.9375 3.58526 3.5225 3.44276 4.3325L2.46026 9.9575C2.37776 10.4525 2.51276 10.955 2.82776 11.3375C3.15026 11.72 3.61526 11.9375 4.11776 11.9375H7.14026V14C7.14026 15.14 8.06276 16.0625 9.26276 16.0625C9.78776 16.0625 10.2603 15.7475 10.4703 15.26L12.3753 10.8125H13.7853C14.7678 10.8125 15.5628 10.0175 15.5628 9.035V4.7075C15.5628 3.7325 14.7678 2.9375 13.7853 2.9375H13.7778ZM11.4378 10.1375L9.43526 14.825C9.40526 14.8925 9.33776 14.945 9.19526 14.945C8.67776 14.945 8.26526 14.525 8.26526 14.0075V10.82H4.11776C3.94526 10.82 3.79526 10.7525 3.69026 10.625C3.57776 10.4975 3.54026 10.3325 3.57026 10.16L4.55276 4.535C4.59776 4.265 4.83026 4.07 5.10776 4.07H11.4378V10.1375ZM14.4303 9.035C14.4303 9.395 14.1378 9.6875 13.7778 9.6875H12.5703V4.0625H13.7778C14.1378 4.0625 14.4303 4.355 14.4303 4.7075V9.035Z" })]
});
const ForwardRef = forwardRef(SvgThumbsDown);
export { ForwardRef as ReactComponent };
